import { useEffect, useRef } from "react"
import { DateUtil } from "../../../utils/date";

declare const flatpickr: any;

interface PreviewFieldProps {
    type: 'text' | 'dropdown' | 'file' | 'date' | 'number' | '',
    name: string,
    options: Array<string | number>,
    mandatory: boolean,
}

function PreviewField(props: PreviewFieldProps) {

    const dateRef = useRef()

    useEffect(() => {
        if (props.type === 'date') {
            let config: any = {}

            let options = props.options;
            if (options) {
                const now = DateUtil.moment();
                const [min, max] = options;

                if (+min >= 0) {
                    config.minDate = DateUtil.moment(now).subtract(min, 'days').toDate()
                }

                if (+max >= 0) {
                    config.maxDate = DateUtil.moment(now).add(max, 'days').toDate()
                }
            }

            flatpickr(dateRef.current, config);
        }

    }, [props])


    return (
        <div className="mb-3">
            <label className="form-label" >{props.name || 'Aún no agregas nombre a este campo'} {props.mandatory ? '*' : ''}</label>
            {
                props.type === 'text' && <input type="text" className="form-control" />
            }
            {
                props.type === 'file' && <input type="file" className="form-control" />
            }
            {
                props.type === 'dropdown' && (
                    <select className="form-control">
                        {Array.isArray(props.options) ? props.options.map((o, i) => <option key={i}>{o}</option>) : <option>Sin opciones</option>}
                    </select>
                )
            }
            {
                props.type === 'date' && <input type="text" className="form-control gb-white-force" ref={dateRef} />
            }
            {
                props.type === 'number' && (
                    <input
                        type="number"
                        className="form-control"
                        step="1.01"
                        onInput={(e) => {
                            const target = e.target as HTMLInputElement;
                            const regex = /^-?\d*(\.\d{0,2})?$/;
                            if (!regex.test(target.value)) {
                                target.value = target.value.slice(0, -1);
                            }
                        }}
                    />
                )
            }

        </div>
    )
}
export default PreviewField